import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
import { useTranslate } from 'react-admin';
import { Link } from 'react-router-dom';
import { OrderModel } from '../../config/types/models/OrderModel';

type IProps = {
  orders: OrderModel[];
};
function LatestOrders({ orders }: IProps) {
  const t = useTranslate();
  const theme = useTheme();

  return (
    <TableContainer sx={{ paddingTop: 2, paddingBottom: 2 }} component={Paper}>
      <Typography textAlign={'center'} variant='h5'>
        {t('latestOrders')}
      </Typography>
      <Table sx={{ minWidth: 650 }} aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell align='left'>#</TableCell>
            <TableCell align='left'>{t('date')}</TableCell>
            <TableCell align='left'>{t('customer')}</TableCell>
            <TableCell align='left'>{t('total')}</TableCell>
            <TableCell align='left'>{t('payment')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders?.map((row) => (
            <TableRow
              key={row.id}
              sx={{
                cursor: 'pointer',
                '&:last-child td, &:last-child th': { border: 0 },
                '&:hover': {
                  opacity: 0.5,
                },
              }}
            >
              <TableCell align='left'>
                <Link to={`/order/${row.id}`}>{row.id}</Link>
              </TableCell>

              <TableCell align='left'>
                {format(new Date(row.createdAt), 'yy-MM-dd hh:mm')}
              </TableCell>
              <TableCell>
                <Link to={`/user/${row.user.id}`}>{row.user.name}</Link>
              </TableCell>

              <TableCell align='left'>{`${row.total} SEK`}</TableCell>

              <TableCell
                color={
                  row.paymentStatus === 'paid'
                    ? theme.palette.success.main
                    : theme.palette.error.main
                }
                align='left'
              >{`${t(row.paymentStatus)}`}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default LatestOrders;
